import { combineEpics } from 'redux-observable'
import { AppState } from '../reducers'
import { Action } from '../reducers/actionTypes'
import { stacFlagsEpic } from '../reducers/cohorts/epics'
import { analyticsEpic } from '../reducers/analytics/epics'
import { impactEpic } from '../reducers/impact/epics'
import { chatbotEpic } from '../reducers/chatbot/epics'
import { productsEpic } from '../reducers/products/epics'
export default combineEpics<Action, Action, AppState>(
  stacFlagsEpic,
  analyticsEpic,
  impactEpic,
  chatbotEpic,
  productsEpic
)
